<template>
	<main class="public-page public-not-found">
		<p class="public-not-found__code">404</p>
		<h1 class="public-not-found__title">Page not found</h1>
		<p class="public-not-found__subtitle">
			The page you requested does not exist or is no longer available.
		</p>
		<router-link
			v-if="homeRoute"
			class="public-not-found__link"
			:to="homeRoute"
		>
			Back to home
		</router-link>
	</main>
</template>

<script>
export default {
	name: 'PublicNotFound',

	computed: {
		homeRoute() {
			const shortId =
				this.$route.params.shortId ||
				this.$store.getters['publicCalendar/shortId']

			if (!shortId) {
				return null
			}

			return {
				name: 'public.calendar',
				params: { shortId },
			}
		},
	},
}
</script>

<style scoped>
.public-not-found__code {
	margin: 0 0 0.5rem;
	font-size: 4rem;
	font-weight: 700;
	line-height: 1;
	letter-spacing: -0.03em;
	color: #2a6b75;
}

.public-not-found__title {
	margin: 0 0 0.75rem;
	font-size: 1.75rem;
	font-weight: 600;
}

.public-not-found__subtitle {
	margin: 0 0 1.5rem;
	max-width: 28rem;
	font-size: 1rem;
	line-height: 1.5;
	color: #3d5c63;
}

.public-not-found__link {
	color: #1f5f68;
	font-weight: 600;
	text-decoration: underline;
}

.public-not-found__link:hover {
	color: #154850;
}
</style>
